import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
// import firebaseConfig from "~/lib/config/firebaseConfig";

const firebaseConfig = {
  apiKey: "AIzaSyAkXUxYe2ZNGjpfS0PFBdPYAgAzFQ13elM",
  projectId: "newsatsangapp",
  messagingSenderId: "154827297872",
  appId: "1:154827297872:web:46e8d37d59fd8a9624ad55",
};

const app = initializeApp(firebaseConfig);

// getMessaging() requires a secure context (HTTPS or localhost).
// Lazily resolve it so importing this module never throws on insecure origins.
export const messaging = (async () => {
  if (typeof window === "undefined") return null;
  if (!window.isSecureContext) return null;
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(app);
})();
